import { api, saveBlob } from './client';
import { endpoints } from './endpoints';

/** Candidate-facing offers. The company side lives in company.api.js. */
export function listOffers(params) {
  return api.getPaginated(endpoints.offers.root, { params });
}

export function getOffer(id) {
  return api.get(endpoints.offers.byId(id));
}

export function acceptOffer(id, message) {
  return api.post(endpoints.offers.accept(id), { message });
}

export function declineOffer(id, message) {
  return api.post(endpoints.offers.decline(id), { message });
}

/** The offer letter as a PDF: the company's signed one, or one generated from the terms. */
export async function downloadOfferLetter(id) {
  const { blob, filename } = await api.download(`${endpoints.offers.byId(id)}/letter`);
  saveBlob(blob, filename.endsWith('.pdf') ? filename : 'offer-letter.pdf');
}
